import React, { Component } from 'react';
import API_URL from '../../../common/url';
import $ from '../../../common/AjaxRequest';
import addToDownloadSite from '../../common/addToDownloadSite';
import TableC from '../../basicElement/TableC';
import Filter from './Filter';

class UserStatistics extends Component {
    state = {
        loading: false,
        pagination: {
            current: 1,
        },
        searchParams: {},
        data: [],
    }

    filterDataWithoutObject = (params) => {
        const obj = {};
        for (let [key, value] of Object.entries(params)) {
            if (typeof value !== 'object') {
                obj[key] = value;
            }
        }
        return obj;
    }

    loadData = () =>{
        this.setState({ loading: true });
        const { pagination, searchParams } = this.state;
        const { areaParams = {} } = searchParams;
        const { current } = pagination;
        
        const params = this.filterDataWithoutObject(searchParams);
        
        const options = {
            method: 'POST',
            url: API_URL.user.queryEmployeeFte,
            data: {
                limit: 3,
                offset: current,
                ...params,
                ...areaParams,
            },
            dataType: 'json',
            doneResult: res => {
                pagination.total = res.totalCount;
                this.setState({
                    loading: false,
                    data: res.datas,
                    pagination,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    search = (params = {}) => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            searchParams: {...params},
        }, () => {
            this.loadData();
        });
    }

    export = () => {
        const { searchParams } = this.state;
        const { areaParams = {} } = searchParams;
        const params = this.filterDataWithoutObject(searchParams);
        addToDownloadSite({ ...params, ...areaParams }, API_URL.user.exportEmployeeFte, 'MAN_HOURS_EXPORT');
    }

    getColumns = () => [{
        title: '工号',
        dataIndex: 'employeeCode',
        key: 'employeeCode',
        fixed: 'left',
        width: 100,
    }, {
        title: '姓名',
        dataIndex: 'userCompellation',
        key: 'userCompellation',
        fixed: 'left',
        width: 100,
    }, {
        title: '工作城市',
        dataIndex: 'workCity',
        key: 'workCity',
        width: 100,
    }, {
        title: '职位',
        dataIndex: 'positionName',
        key: 'positionName',
        width: 100,
    }, {
        title: '所属部门',
        dataIndex: 'enterpriseDepartmentName',
        key: 'enterpriseDepartmentName',
        width: 100,
    }, {
        title: '直线主管',
        dataIndex: 'leaderName',
        key: 'leaderName',
        width: 80,
    }, {
        title: '目前状态',
        dataIndex: 'employeeStatus',
        key: 'employeeStatus',
        width: 80,
        render: (text, record) => {
            if (text == 'LEFT') {
                return '离职';
            } else if (text == 'WORKING') {
                return '在职';
            }
        }
    }, {
        title: 'JDE主项目号',
        dataIndex: 'jdeMainCode',
        key: 'jdeMainCode',
        width: 100,
    }, {
        title: 'JDE项目号',
        dataIndex: 'jdeCode',
        key: 'jdeCode',
        width: 100,
    }, {
        title: '角色',
        dataIndex: 'roleCode',
        key: 'roleCode',
        width: 80,
    }, {
        title: '项目简称',
        dataIndex: 'investigationName',
        key: 'investigationName',
        width: 120,
    }, {
        title: '业务线',
        dataIndex: 'lineOfBusinessString',
        key: 'lineOfBusinessString',
        width: 80,
    }, {
        title: '执行业务线二级分类',
        dataIndex: 'secondLineNames',
        key: 'secondLineNames',
        width: 100,
    }, {
        title: '大项目经理',
        dataIndex: 'projectManagerAName',
        key: 'projectManagerAName',
        width: 100,
    }, {
        title: '研究中心名称',
        dataIndex: 'investigationSiteName',
        key: 'investigationSiteName',
        width: 120,
    }, {
        title: '项目确认FTE',
        dataIndex: 'fte',
        key: 'fte',
        width: 100,
    }, {
        title: '计入完工的项目确认FTE',
        dataIndex: 'finishedFte',
        key: 'finishedFte',
        width: 100,
    }, {
        title: '非项目确认FTE',
        dataIndex: 'dailyFte',
        width: 120,
        key: 'dailyFte',
    }]

    getDataSource = () => {
        const { data = [] } = this.state;
        let key = 0;
        const dataSource = [];
        
        if (data.length > 0) {
            data.map((dataItem, dataIndex) => {
                if (dataItem.iSUFMSList.length > 0) {
                    dataItem.iSUFMSList.map((item, index) => {
                        if (dataItem.employeeCode == '合计' || dataItem.employeeCode == '总计') {
                            dataItem.employeeCode = <span style={{fontWeight: 'bold'}}>{dataItem.employeeCode}</span>;
                            item.fte = <span style={{fontWeight: 'bold'}}>{item.fte}</span>;
                            item.finishedFte = <span style={{fontWeight: 'bold'}}>{item.finishedFte}</span>;
                            item.dailyFte = <span style={{fontWeight: 'bold'}}>{item.dailyFte}</span>;
                        }
                        dataSource.push({
                            key: key++,
                            ...dataItem,
                            ...item,
                            positionName: dataItem.positionName,
                            employeeCode: dataItem.employeeCode,
                            userCompellation: dataItem.userCompellation,
                            workCity: dataItem.workCity,
                            enterpriseDepartmentName: dataItem.enterpriseDepartmentName,
                            leaderName: dataItem.leaderName,
                            statusStr: (dataItem.statusStr && dataItem.statusStr.length) > 2 ? <span>{dataItem.statusStr.slice(0, 2)}<br/>{dataItem.statusStr.slice(2)}</span>: dataItem.statusStr,
                        });
                    })
                } else {
                    dataSource.push({
                        key: key++,
                        ...dataItem,
                        statusStr: (dataItem.statusStr && dataItem.statusStr.length) > 2 ? <span>{dataItem.statusStr.slice(0, 2)}<br/>{dataItem.statusStr.slice(2)}</span>: dataItem.statusStr,
                    });
                }
            });
        }
        return dataSource;
    }

    handleTableChange = (params) => {
        this.setState({ ...params }, () => {
            this.loadData();
        });
    }
    render() {
        const { loading, pagination } = this.state;
        const dataSource = this.getDataSource();
        pagination.pageSize = dataSource.length;
        return (
            <div>
                <Filter search={this.search} export={this.export}/>
                <TableC
                    loading={loading}
                    scrollY={460}
                    pagination={pagination}
                    columns={this.getColumns()}
                    data={dataSource}
                    onChange={this.handleTableChange}
                />
            </div>
        )
    }
}

export default UserStatistics;



// WEBPACK FOOTER //
// ./src/components/user/manHour/UserStatistics.js